import axios from 'axios';

class FamiliasDataService {
  getAll() {
    return axios.get(`/api/familias`);
  }

  getSimple() {
    return axios.get(`/api/familias/search`);
  }

  get(id) {
    return axios.get(`/api/familias/${id}`);
  }

  create(data) {
    return axios.post(`/api/familias`, data);
  }

  update(id, data) {
    return axios.put(`/api/familias/${id}`, data);
  }

  delete(id) {
    return axios.delete(`/api/familias/${id}`);
  }

  deleteAll() {
    return axios.delete(`/api/familias`);
  }
}

export default new FamiliasDataService();